module.exports = __webpack_public_path__ + "static/media/pirate2.0e836945.png";